import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Pricing.css'; // Reuse existing styles

const SubscriptionCancelPage: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Optional: Log cancellation attempt if needed
    }, []);

    return (
        <div className="pricing-container" style={{ justifyContent: 'center', textAlign: 'center' }}>
            <div className="pricing-card featured" style={{ maxWidth: '500px', margin: '0 auto', border: '1px solid #ddd' }}>
                <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⚠️</div>
                <h1 style={{ color: '#d32f2f' }}>Payment Canceled</h1>
                <p style={{ fontSize: '1.2rem', color: '#666', margin: '20px 0' }}>
                    It looks like you canceled the payment process. No worries!
                </p>
                <p>
                    Your subscription has not been activated and you have not been charged.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '30px' }}>
                    <button
                        className="cta-button"
                        onClick={() => navigate('/pricing')}
                    >
                        Try Again
                    </button>
                    <button
                        className="cta-button secondary"
                        onClick={() => navigate('/dashboard')}
                        style={{ backgroundColor: 'transparent', color: '#666', border: '1px solid #ccc' }}
                    >
                        Return to Dashboard
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionCancelPage;
